import { computed } from 'vue';
import { useStoreGetters } from 'dashboard/composables/store';

/**
 * Composable to determine if the current user is an administrator or supervisor.
 * @returns {Boolean} - True if the current user is an administrator or supervisor, false otherwise.
 */
export function useAdmin() {
  const getters = useStoreGetters();

  const currentUserRole = computed(() => getters.getCurrentRole.value);
  const isAdmin = computed(
    () =>
      currentUserRole.value === 'administrator' ||
      currentUserRole.value === 'supervisor'
  );

  /**
   * Check if the current user is an administrator only (not supervisor).
   * Used for delete operations that should only be available to administrators.
   * @returns {Boolean} - True if the current user is an administrator only, false otherwise.
   */
  const isAdministratorOnly = computed(
    () => currentUserRole.value === 'administrator'
  );

  return {
    isAdmin,
    isAdministratorOnly,
  };
}
